import axios from 'axios'

async function delete_template(data,add_template,add_templates,templates,dispatch,setDeleting,setMessage,setOpen,navigate){
    try{

    setDeleting(true)
    const deleteTemp = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}delete-template/`,{id:data?.id,email:data?.email},{
        headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${data?.token}`
            }
    }).catch(err=>{console.log(err)})

        if (deleteTemp?.status == 200 && deleteTemp?.data.success) {

            const filterData = templates.filter((item)=>item.id !== data?.id)

            const newTemps = [...filterData]

            await dispatch(add_templates(newTemps))
            await dispatch(add_template([]))

            localStorage.setItem("iTest_template",JSON.stringify({}))

            setMessage("Template deleted")
            setOpen(true)
            setDeleting(false)
            navigate("/template")
            
        }else{
            setMessage(deleteTemp?.data?.message)
            setOpen(true)
            setDeleting(false)
        }
    }catch(err){
        console.log(err)
        setDeleting(false)
    }
}

export default delete_template